import React from 'react'

const BoxItem1 = (props) => {
    const {title, number} = props

    return <div className="BoxItem PageHeading">
        <div className="d-flex justify-content-between w-100">
            <div className="Title">
                <div className="Name">{title}</div>
                <div className="Number">{number ? `${number} VNĐ` : 'N/A'}</div>
            </div>
            <button className="ButtonCustom">Add funds</button>
        </div>
    </div>
}

export default BoxItem1
